import { httpClient } from "./httpClient";
export const PUBLIC_ROUTES = [
  "/auth/signin",
  "/auth/refresh",
  "/auth/signup",
];
let isRefreshing = false;
let queue = [];

const processQueue = (error) => {
  queue.forEach((p) => (error ? p.reject(error) : p.resolve()));
  queue = [];
};

export const refreshInterceptor = async (error) => {
  const originalRequest = error.config;
if (!error?.config) {
    return Promise.reject(error);
  }
  const requestUrl = originalRequest.url;
  // 🚫 Skip refresh for public/auth routes
  if (PUBLIC_ROUTES.some(route => requestUrl.includes(route))) {
    return Promise.reject(error);
  }
  if (error.response?.status !== 401 || originalRequest._retry) {
    return Promise.reject(error);
  }

  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      queue.push({ resolve, reject });
    }).then(() => {
      return httpClient(originalRequest);
    });
  }

  originalRequest._retry = true;
  isRefreshing = true;

  try {
    // Refresh endpoint sets new httpOnly cookies automatically.
    await httpClient.post("/auth/refresh");

    processQueue(null);

    return httpClient(originalRequest);
  } catch (err) {
    processQueue(err);

    // hard logout — redirect to login
    window.location.href = "/auth/login";

    return Promise.reject(err);
  } finally {
    isRefreshing = false;
  }
};
